import { PdfTableCell } from '@/components/pdf/PdfTableCell';
import { styles } from '@/components/pdf/styles';
import { Product } from '@/services/api/contracts/catalog/types';
import { Text, View } from '@react-pdf/renderer';
import { FunctionComponent } from 'react';
import {
  PO_COMPLETE_DOCUMENT_PRODUCT_TABLE_NAME_CELL_WIDTH,
  PO_COMPLETE_DOCUMENT_PRODUCT_TABLE_PRICE_CELL_WIDTH,
  PO_COMPLETE_DOCUMENT_PRODUCT_TABLE_QTY_CELL_WIDTH,
  PO_COMPLETE_DOCUMENT_PRODUCT_TABLE_WARRANTY_CELL_WIDTH
} from './consts';
import PurchaseOrderCompleteDocumentTableRow from './PurchaseOrderCompleteDocumentTableRow';

export interface PurchaseOrderCompleteDocumentTableData {
  name: string;
  product: Product;
  qty: number;
  price: number;
  totalPrice: number;
}

interface Props {
  data: PurchaseOrderCompleteDocumentTableData[];
  regionCode?: string;
}

const PurchaseOrderCompleteDocumentTable: FunctionComponent<Props> = ({ data, regionCode }) => {
  return (
    <View style={styles.table}>
      <View style={styles.tableRow}>
        <PdfTableCell width={PO_COMPLETE_DOCUMENT_PRODUCT_TABLE_NAME_CELL_WIDTH}>
          <Text style={styles.tableHeaderCell}>Details/Description</Text>
        </PdfTableCell>
        <PdfTableCell width={PO_COMPLETE_DOCUMENT_PRODUCT_TABLE_WARRANTY_CELL_WIDTH} height={20}>
          <Text style={styles.tableHeaderCell}>Warranty</Text>
        </PdfTableCell>
        <PdfTableCell width={PO_COMPLETE_DOCUMENT_PRODUCT_TABLE_QTY_CELL_WIDTH}>
          <Text style={styles.tableHeaderCell}>Qty</Text>
        </PdfTableCell>
        <PdfTableCell width={PO_COMPLETE_DOCUMENT_PRODUCT_TABLE_PRICE_CELL_WIDTH}>
          <Text style={styles.tableHeaderCell}>Unit Price</Text>
        </PdfTableCell>
        <PdfTableCell width={PO_COMPLETE_DOCUMENT_PRODUCT_TABLE_PRICE_CELL_WIDTH} lastCell>
          <Text style={styles.tableHeaderCell}>Line Total</Text>
        </PdfTableCell>
      </View>
      {data.map(item => (
        <PurchaseOrderCompleteDocumentTableRow data={item} key={item.product.productId} regionCode={regionCode} />
      ))}
    </View>
  );
};

export default PurchaseOrderCompleteDocumentTable;
